import React from 'react';
import { Panel, Glyphicon } from 'react-bootstrap';
import { connect } from 'react-redux';
import {
    getSettings,
    updateSettings,
    clearUpdateSettings
} from '../../../actions/settings';
import { Table } from '../departments/Table'
import { departments } from '../../../constants/settingTypes';
import EditModal from './EditModal';
import * as permissions from '../../../constants/permissions';
import * as depTypes from '../../../constants/dcDepartmentTypes';
import { Col } from "react-bootstrap";

let Departments = class extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            showAddModal: false,
            showUpdateModal: false,
            departmentToEdit: null
        }

        this._load = this._load.bind(this);
        this._onAddClick = this._onAddClick.bind(this);
        this._onEditClick = this._onEditClick.bind(this);
        this._onClose = this._onClose.bind(this);
        this._addDepartment = this._addDepartment.bind(this);
        this._updateDepartment = this._updateDepartment.bind(this);

    }

    componentDidMount() {
        this._load();
    }

    _load() {
        this.props.getSettings(departments);
    }

    _onAddClick() {
        this.setState({ showAddModal: true });
    }

    _addDepartment(department) {
        this.props.updateSettings(departments, department);
    }

    _onClose() {
        this.setState({
            showAddModal: false,
            departmentToEdit: null,
            showUpdateModal: false
        });
        this.props.clearUpdateSettings(departments);
    }

    _onEditClick(department) {
        this.setState({ departmentToEdit: department, showUpdateModal: true })
    }

    _updateDepartment(department) {
        this.props.updateSettings(departments, department, department.Id);
    }

    render() {
        const { departments: { data, fetching } } = this.props;
        const { showAddModal, showUpdateModal, departmentToEdit } = this.state;
        const modalProps = {
            isNew: showAddModal,
            initialValues: departmentToEdit ? departmentToEdit : {
                Address: undefined,
                FullName: undefined,
                Phone: undefined,
                IsActive: true
            },
            onClose: this._onClose,
            onSubmit: showAddModal ? this._addDepartment : this._updateDepartment
        };
        const isReadOnly = !permissions.isAllowedFor(permissions.allowedEditSettings);
        const addByttonClass = `add-glyph${isReadOnly ? '.disabled' : ''}`;

        const receivingPoints = data ? data.filter(d => d.Type == depTypes.RECEIVING_POINT) : undefined;
        const agencyReceptionPoint = data ? data.filter(d => d.Type == depTypes.AGENCY_RECEPTION_POINT) : undefined;
        const factories = data ? data.filter(d => d.Type == depTypes.FACTORY) : undefined;
        const agencyFactories = data ? data.filter(d => d.Type == depTypes.AGENCY_FACTORY) : undefined;
        const mobilePoint = data ? data.filter(d => d.Type == depTypes.MOBILE_POINT) : undefined;

        return (
            <Panel>
                <Panel.Heading >
                    <span>Отделы</span>
                    <Glyphicon
                        glyph='plus'
                        title='Добавить'
                        className={addByttonClass} style={{ float: 'right' }}
                        onClick={isReadOnly ? undefined : this._onAddClick} />
                </Panel.Heading>
                <Panel.Body className='departments-container'>
                    <Col>
                        <p><b>Точка приема</b></p>
                        <Table
                            fetching={fetching}
                            departments={receivingPoints}
                            onEdit={this._onEditClick}
                            isReadOnly={isReadOnly}
                            isReceptionPoint />
                        <p><b>Агентская точка приема</b></p>
                        <Table
                            fetching={fetching}
                            departments={agencyReceptionPoint}
                            onEdit={this._onEditClick}
                            isReadOnly={isReadOnly} />
                        
                        <p><b>Фабрика</b></p>
                        <Table
                            fetching={fetching}
                            departments={factories}
                            onEdit={this._onEditClick}
                            isReadOnly={isReadOnly} />
                        
                        <p><b>Агентская фабрика</b></p>
                        <Table
                            fetching={fetching}
                            departments={agencyFactories}
                            onEdit={this._onEditClick}
                            isReadOnly={isReadOnly} />

                        <p><b>Мобильная точка</b></p>
                        <Table
                            fetching={fetching}
                            departments={mobilePoint}
                            onEdit={this._onEditClick}
                            isReadOnly={isReadOnly} />
                    </Col>
                    {(showAddModal || showUpdateModal) && <EditModal {...modalProps} />}
                </Panel.Body>
            </Panel>
        );
    }
}

Departments = connect(state => ({
    departments: state.application.get('settings')[departments]
}), { getSettings, updateSettings, clearUpdateSettings })(Departments);

export default Departments;


// WEBPACK FOOTER //
// ./src/components/settings/departments/Departments.jsx